import Layout from "@/layout/Layout";
import React from "react";
import globalStyle from "@/styles/Global.scss";
import {useHistory} from "react-router";
import RestrictionPanel from "@/components/term/RestrictionPanel";
import MButton from "@/components/atom/MButton";

const Term = () => {
  const history = useHistory()
  const goBack = () => {
    history.push(`/termInfo`)
  }

  return (
    <>
      <Layout title={'ご利用規約'}>
        <div>
          <RestrictionPanel/>
          <div style={{marginLeft: '100px'}}>
            <MButton image={'back.png'} onClick={goBack}/>
          </div>
        </div>
      </Layout>
    </>
  )

}

export default Term
